import useCartStore from '../context/CartStore';
import toast from 'react-hot-toast';
import { productos } from '../data/db/Products';


// Modifica la función handleBuy
export const handleBuy = (producto: typeof productos[0]) => {
    const cantidadInput = document.getElementById(`cantidad-${producto.id}`) as HTMLInputElement;
    const cantidad = parseInt(cantidadInput?.value || '1');

    try {
      useCartStore.getState().addToCart({
        id: producto.id,
        titulo: producto.titulo,
        categoria: producto.categoria,
        precio: producto.precio,
        cantidad: 0, // Valor temporal, se actualizará en el store
        stock: producto.stock
      }, cantidad);
      
      toast.success(`¡${producto.titulo} agregado al carrito!`);
    } catch (error) {
      if (error instanceof Error) {
        toast.error(error.message);
      } else {
        toast.error('Error al agregar el producto al carrito');
      }
    }
  };



  